// extracted by mini-css-extract-plugin
module.exports = {"selectDropdown":"chainSalesStatistics_selectDropdown__y1nmA"};